import { LoadingButton } from "@mui/lab";
import { Box, Grid, Typography } from "@mui/material";
import { CheckoutContext } from "contexts/Checkout";
import { useContext } from "react";
import { AddOnItemName } from "schemas/dashboard";

import { useCheckout } from "components/StripeCheckout/useCheckout";

import styles from "./styles";

const PitchingTemplateBundle = () => {
  const { addOnItems, applyAddOnLoading } = useContext(CheckoutContext);
  const { applyAddOnItem } = useCheckout();

  const exists = addOnItems?.find(
    (x) => x.name === AddOnItemName.pitching_templates,
  );

  const addToOrderButton = exists ? (
    <Box sx={{ px: 2, fontSize: 10, color: "green.main" }}>
      <strong>
        Added <Box component="i" className="fa-regular fa-check" />
      </strong>
    </Box>
  ) : (
    <LoadingButton
      disableElevation
      fullWidth
      variant="contained"
      sx={{ px: 2, ml: 1 }}
      loading={applyAddOnLoading === AddOnItemName.pitching_templates}
      onClick={() =>
        applyAddOnItem({
          name: AddOnItemName.pitching_templates,
          quantity: 1,
        })
      }
    >
      + Pitch Template
    </LoadingButton>
  );

  return (
    <Grid sx={styles.card}>
      <Box sx={styles.enhance}>Enhance Your Plan</Box>
      <Typography variant="h6" gutterBottom>
        Make it a Bundle: Custom Pitch Template 📝
      </Typography>

      <Grid container alignItems="center" sx={{ mb: 2 }}>
        <Typography
          component="div"
          sx={{ color: "green.main", fontSize: 16, fontWeight: 600 }}
          gutterBottom
        >
          $24.00/template{" "}
        </Typography>
        <Box component="span" sx={styles.saveBundle}>
          SAVE 20%
        </Box>{" "}
        <Box sx={[styles.annotationPrice, { fontWeight: 600 }]}>
          One-time fee
        </Box>
      </Grid>

      <Typography>
        Make every word count! A professional copywriter will polish your pitch
        so brands can't wait to work with you.
      </Typography>

      <Grid item xs={12} sx={{ mt: 2, ml: -2 }}>
        {addToOrderButton}
      </Grid>
    </Grid>
  );
};

export default PitchingTemplateBundle;
